// extracted by mini-css-extract-plugin
export default {"accreditationDays":"paymentTypeForm_accreditationDays__Qmzma"};